import {useSnackbar} from 'notistack'
import {useState} from 'react'
import {FormModal} from 'src/components/modal/FormModal'
import api from 'src/services/api'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'
import {Input} from '../../../../components/input/Input'

type CreatePlateProps = {
  isOpen: boolean
  closeModal: () => void
  listId: number
  refreshList: () => void
}

function CreatePlateModal(props: CreatePlateProps) {
  const {isOpen, closeModal, listId, refreshList} = props
  const [plate, setPlate] = useState('')
  const [description, setDescription] = useState('')
  const {enqueueSnackbar} = useSnackbar()

  function handleClose() {
    setPlate('')
    setDescription('')
    closeModal()
  }

  async function handleSaveList() {
    try {
      await api.lpr.createPlate(String(listId), {
        licensePlate: plate,
        description,
      })
      enqueueSnackbar('Placa vinculada com sucesso', {variant: 'success'})
      refreshList()
      handleClose()
    } catch (err) {
      handleErrorWithSnackbar(enqueueSnackbar, err, 'Erro ao vincular placa')
    }
  }

  function plateIsValid(value: string) {
    const validPlate = /^[A-Z]{3}[0-9]{1}[A-Z0-9]{1}[0-9]{2}$/i.test(value) ? value : ''
    if (!validPlate) enqueueSnackbar('Informe uma placa válida', {variant: 'info'})
    else {
      setErrorMessage(undefined)
      setPlate(value)
    }
    return validPlate
  }

  const [errorMessage, setErrorMessage] = useState<string | undefined>()

  return (
    <FormModal
      isOpen={isOpen}
      onClose={handleClose}
      title='Cadastro de Placa'
      subtitle='Informe a placa do veículo'
      description='Utilize somente números e letras. Exemplo: ABC1234'
      width='400px'
      onCancel={handleClose}
      onSave={handleSaveList}
      saveDisabled={!!errorMessage || !plate || !description}>
      <Input.Root
        labelFontSize='14px'
        borderColor='#D0D5DD'
        fontSize='12px'
        labelFontWeight='400'
        label='Placa'
        onChange={(e) => {
          plateIsValid(e.target.value)
        }}
        mask={(value) => value.toUpperCase()}
        required
      />
      <Input.Root
        labelFontSize='14px'
        borderColor='#D0D5DD'
        fontSize='12px'
        labelFontWeight='400'
        label='Descrição'
        onChange={(e) => setDescription(e.target.value)}
        required
      />
    </FormModal>
  )
}

export default CreatePlateModal
